import { useLocation, useMatch, useNavigate } from "react-router-dom";
import profile_placeholder from "../assets/images/profile_placeholder.png";
import { useState, useEffect, useContext, useRef, useCallback } from "react";
import henceforthApi from "../utils/henceforthApi";
import { GlobalContext } from "../context/Provider";
import Modal from "react-bootstrap/Modal";
import ViewReportedChats from "../UserActivity/ViewReportedChats";
import { Table, Avatar, Spin, Tabs, Tag, Button } from "antd";
import { Link } from "react-router-dom";
import { getUserProfileImage } from "../utils/constant_value";


import moment from "moment/moment";

export default () => {
  const match = useMatch("/reported-chat/:id/view");
  const location = useLocation();
  const { record } = location.state || {}; // 👈 access passed state
  console.log("record" , record)
  const { authState, scrollToTop, handleError } = useContext(GlobalContext);
  const [userDetails, setUserDetails] = useState({
    _id: "",
    social_type: null,
    social_token: null,
    profile_pic: "fe",
    cover_image: null,
    full_name: "",
    email: "",
    new_email: null,
    username: "",
    country_code: null,
    phone_no: 0,
    new_phone_no: 0,
    new_country_code: null,
    email_otp: "",
    phone_otp: 0,
    account_type: "",
    gender: "",
    customer_id: null,
    bank_account_id: null,
    available_coins: 0,
    birthday: null,
    hobbies: [],
    is_blocked: false,
    is_deleted: false,
    is_email_verified: false,
    is_phone_verified: false,
    account_status: "",
    version: null,
    version_status: "",
    device_type: "",
    created_at: "",
  });
  henceforthApi.setToken(authState.access_token);
  const [loading, setLoading] = useState(false);
 
  const [reportedMessage, setReportedMessage] = useState([]);

  const userDetailsPost = async (id) => {
    try {
      setLoading(true);
      let apiRes = await henceforthApi.Reported.reportedMessage(
       id
      )
  
      const sortedMessages = apiRes?.sort(
        (a, b) => Number(b.created_at) - Number(a.created_at)
      );

      setReportedMessage(sortedMessages);
      setLoading(false);
    } catch (error) {
      handleError(error)
      setLoading(false)
    }
  }

  useEffect(() => {
    userDetailsPost(match?.params?.id)
    scrollToTop();
  }, [match?.params?.id]);

  const [showImage, setShowImage] = useState();

  const handleShow = () => {
    setShowImage(true)
  }

  const [showCover, setShowCover] = useState();

  const handleShowCover = () => {
    setShowCover(true)
  }
  
  return (
    <>
      <div className="row animated fadeInRight">
        <div className="col-md-12" style={{ color: "#000000" }}>
          <div className="ibox">
            {/* <div className="ibox-title">
              <h5 style={{ fontSize: "16px" }}>User Details</h5>
            </div> */}
            <div className="col-sm-12">
              <Modal
                show={showImage}
                onHide={() => setShowImage(false)}
                backdrop="static"
                keyboard={false}
                centered
                className="confirm-box-modal"
              >
                <Modal.Header closeButton>
                  {record?.report_by?.full_name}
                </Modal.Header>
                <Modal.Body closeButton>
                  <img
                    src={getUserProfileImage(record?.report_by?.profile_pic)}
                    alt="ProfileImage"
                    className="ZoomImage "
                  />
                </Modal.Body>
              </Modal>
              {/* COver Image modal */}
              <Modal
                show={showCover}
                onHide={() => setShowCover(false)}
                backdrop="static"
                keyboard={false}
                centered
                className="confirm-box-modal"
              >
                <Modal.Header closeButton>
                  {record?.report_by?.full_name}
                </Modal.Header>
                <Modal.Body closeButton>
                  <img
                    src={
                      record?.report_by?.cover_image
                        ? `${henceforthApi?.API_FILE_ROOT_ORIGINAL}${record?.report_by?.cover_image}`
                        : profile_placeholder
                    }
                    alt="ProfileImage"
                    className="ZoomImage"
                  />
                </Modal.Body>
              </Modal>
            </div>
            <div className="ibox-content">
              <div className="text-center">
                {/* <div className="row">
                  <div className="col-md-12">
                    <img className="CoverImage "
                      onClick={() => handleShowCover(record?.report_by?.cover_image)}
                      src={
                        record?.report_by?.cover_image
                          ? `${henceforthApi?.API_FILE_ROOT_ORIGINAL}${record?.report_by?.cover_image}`
                          : profile_placeholder
                      } alt="" />
                  </div>
                </div> */}
                <div className="row align-item-center">
                  {/* col-4  */}
                  {/* <div className="col-md-4 position-relative">
                    <div className="DetailsProfileImage text-center">
                      <img
                        onClick={() => handleShow(record?.report_by?.profile_pic)}
                        src={getUserProfileImage(record?.report_by?.profile_pic)}
                        alt="ProfileImage"
                        className="detail-img d-flex align-items-center"
                      /> 
                    </div>
                  </div> */}
                  {/* col-8  */}
                  <div className="col-md-12 py-4">
                    <div className="row">
                      <div className="col-6" style={{ textAlign: "left" }}>
                        <div className="UsernameDetailsSpacing">
                          <label style={{ fontSize: "12px", color: "#5E5E5E" }}>
                          Reported by
                          </label>
                          <br></br>
                             <span>
                              <Avatar
                                src={getUserProfileImage(record?.report_by?.profile_pic, 'medium')}
                              />
                            <Link
                              to={`/user/${record?.report_by?._id}/1/1?type=posts`}
                              className="Details_of_User"
                            >
                              <span style={{ marginLeft: 8 }}>{record?.report_by?.full_name || "-"}</span> 
                            </Link >
                            </span>
                        </div>
                        <div className="UsernameDetailsSpacing">
                          <label style={{ fontSize: "12px", color: "#5E5E5E" }}>
                            Email
                          </label>
                          <br></br>
                          <text style={{ fontSize: "16px", color: "#000" }}>
                            {record?.report_by.email}
                          </text>
                        </div>
                      </div>
                      <div
                        className="col-6 messageDeatilscol8"
                        style={{ textAlign: "left", color: "" }}
                      >
                          {
                            record?.chat_type === "USER" ? 
                            <>
                          <div className="UsernameDetailsSpacing">
                            <label style={{ fontSize: "12px", color: "#5E5E5E" }}>
                             Reported to
                            </label>
                            <br></br>
                              <span>
                              <Avatar
                                src={getUserProfileImage(record?.report_to?.profile_pic, 'medium')}
                              />
                            <Link
                              to={`/user/${record?.report_to?._id}/1/1?type=posts`}
                              className="Details_of_User"
                            >
                              <span style={{ marginLeft: 8 }}>{record?.report_to?.full_name || "-"}</span> 
                            </Link >
                            </span>
                          </div>
                          <div className="UsernameDetailsSpacing">
                            <label style={{ fontSize: "12px", color: "#5E5E5E" }}>
                              Email
                            </label>
                            <br></br>
                            <text style={{ fontSize: "16px", color: "#000" }}>
                              {record?.report_to.email}
                            </text>
                          </div>
                            </> : 
                            <div className="UsernameDetailsSpacing">
                          <label style={{ fontSize: "12px", color: "#5E5E5E" }}>
                            Reported to
                          </label>
                          <br></br>
                          <text style={{ fontSize: "16px", color: "#000" }}>
                            {record?.group_name}
                          </text>
                        </div>
                          }
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      {/* {loading ? <Spinner/> : */}
      <div className="row">
        <div className="col-md-12">
          <div className="ibox animated fadeInRight">
            <div className="ibox-title">
              <div className="title-head d-flex justify-content-between align-items-center flex-row">
                <h5>Message</h5>
              </div>
              <div className="tab-content" id="myTabContent">
                <div
                  className={`tab-pane fade show active`}
                  id="activity"
                  role="tabpanel"
                  aria-labelledby="contact-tab"
                >
                <Spin spinning={loading}>
                  <ViewReportedChats loading={loading} messages={reportedMessage} />
                </Spin>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
